const attributes = [
    {
        isHeader: true,
        name: 'friendlyName',
        sortable: true,
        sortBy: 'friendlyName',
        label: 'ViewItem',
        headerCellStyles: {
            width: '15%',
            minWidth: '130px',
        },
        styles: {
            color: '#9230c5',
            fontSize: '16px',
            fontWeight: 'bold',
            marginTop: '6px',
            marginLeft: '10px',
            '&:hover': {
                textDecoration: 'underline',
            },
        },
        link: false,
    },
    {
        name: 'businessRequestNumber',
        label: 'RequestNo',
        sortBy: 'businessRequestNumber',
        avatar: false,
        sortable: true,
        headerCellStyles: {
            minWidth: '11rem',
        },
        styles: {
            marginTop: '6px',
            fontSize: '13px',
            whiteSpace: 'normal',
            color: '#282828',
        },
    },
    {
        name: 'initiatorPersonFriendlyName',
        label: 'Initiator',
        hideValue: true,
        sortable: true,
        sortBy: 'initiatorPersonFriendlyName',
        avatar: true,
        // imgProp: 'approverPersonURL',
        headerCellStyles: {
            minWidth: '20rem',
        },
        styles: {
            minWidth: '20rem',
        },
        textStyles: {
            color: '#282828',
            fontSize: '13px',
            whiteSpace: 'normal',
            wordWrap: 'break-word',
            wordBreak: 'break-word',
        },
    },
    {
        name: 'processStatus',
        hideValue: true,
        label: 'ItemStatus',
        sortable: true,
        sortBy: 'processStatus',

        headerCellStyles: {
            width: '15%',
            minWidth: '15%',
        },
        styles: {
            padding: '20px 0px',
        },
        component: {
            componentName: 'StatusIndicator',
            name: 'processStatus',
            props: {
                size: 'medium',
            },
        },
    },
    {
        name: 'fulfillmentStatusFriendlyName',
        hideValue: true,
        label: 'FullfillmentStatus',
        sortable: true,
        sortBy: 'fulfillmentStatusFriendlyName',

        headerCellStyles: {
            width: '15%',
            minWidth: '15%',
        },
        styles: {
            padding: '20px 0px',
        },
        component: {
            componentName: 'StatusIndicator',
            name: 'fulfillmentStatusFriendlyName',
            props: {
                size: 'medium',
            },
        },
    },
    {
        name: 'percentageCompleted',
        label: 'PercentageComplete',
        sortBy: 'percentageCompleted',
        avatar: false,
        sortable: true,
        hideValue: true,
        headerCellStyles: {
            minWidth: '12.5rem',
        },
        styles: {
            marginTop: '6px',
            fontSize: '13px',
            whiteSpace: 'normal',
            color: '#282828',
        },
        component: {
            componentName: 'Percentage',
        },
    },
    {
        name: 'fulFillmentScheduleDateUtc',
        hideValue: true,
        label: 'FullfillmentScheduled',
        sortable: true,
        sortBy: 'fulFillmentScheduleDateUtc',

        headerCellStyles: {
            width: '15%',
            minWidth: '15%',
        },
        component: { componentName: 'CellDateTime' },
    },

    {
        name: 'requestDataAssigneePreviewName',
        label: 'AccessAssignee',
        sortBy: 'requestDataAssigneePreviewName',
        avatar: false,
        sortable: true,
        headerCellStyles: {
            maxWidth: '150px',
        },
        styles: {
            maxWidth: '150px',
            marginTop: '6px',
            fontSize: '13px',
            whiteSpace: 'normal',
            color: '#282828',
        },
    },

    {
        name: 'azRiskLevelFriendlyName',
        hideValue: true,
        label: 'RiskLevel',
        sortable: true,
        sortBy: 'azRiskLevelFriendlyName',
        headerCellStyles: {
            width: '10%',
            maxWidth: '105px',
        },
        styles: {
            maxWidth: '105px',
        },
        component: { componentName: 'RiskIndicator', name: 'riskLevel' },
    },
    {
        hideValue: true,

        button: { name: 'ShowHideButton' },
    },
]
export const expandedAttributes = () => [
    // Row 1 Starts
    [
        {
            label: 'TargetAdditionalAssignee',
            name: 'requestDataTargetResourcePreviewName',
            styles: {
                paddingRight: '10px',
            },
        },
        {
            label: 'CreatedDate',
            name: 'createdDateUtc',
            component: {
                componentName: 'CellDateTime',
            },
        },
        {
            label: 'LastApprover',
            name: 'lastApproverPersonFriendlyName',
            component: {
                componentName: 'Person',
            },
        },

        {
            label: 'LastDecision',
            name: 'lastApprovalFlowDecisionName',
            component: {
                componentName: 'StatusIndicator',
            },
        },
        {
            label: 'EndDate',
            name: 'endDateUtc',
            component: {
                componentName: 'CellDateTime',
            },
        },
        {
            label: 'ProcessStatus',
            name: 'processStatus',
            component: {
                componentName: 'StatusIndicator',
                props: {
                    size: 'medium',
                },
            },
        },
        {
            label: 'ProcessTime',
            name: 'processTimeUtc',
            component: {
                componentName: 'CellDateTime',
            },
        },
    ],
]
export default attributes
